<div class="mt-2">
    <!-- Streaming indicator -->
    @if (facade.isStreaming()) {
        <div id="ai-chat-thinking" class="text-muted small text-center py-1">
            <i class="fa fa-spinner fa-spin"></i> {{ "aiReport.lbl_thinking" | translate}}
        </div>
    }

    <div class="input-group">
        <textarea id="ai-chat-input" #textareaEl class="form-control" rows="2" [placeholder]="'aiReport.lbl_type_here' | translate"
            [ngModel]="facade.draft()" (ngModelChange)="facade.draft.set($event)" (keydown.enter)="onEnter($event)">
        </textarea>
        <div class="input-group-append">
            <button type="button" id="ai-chat-send" class="btn btn-send" (click)="facade.isStreaming() ? facade.stop() : facade.send()" [disabled]="!facade.canSend() && !facade.isStreaming()"
                aria-label="Send">
                <i class="fa" [ngClass]="facade.isStreaming() ? 'fa-stop' : 'fa-paper-plane'"></i>
            </button>
        </div>
    </div>
</div>
